import { render, staticRenderFns } from "./SecondComp.vue?vue&type=template&id=1a7839ea&scoped=true&"
import script from "./SecondComp.vue?vue&type=script&lang=js&"
export * from "./SecondComp.vue?vue&type=script&lang=js&"
import style0 from "./SecondComp.vue?vue&type=style&index=0&id=1a7839ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7839ea",
  null
  
)

export default component.exports